import React, { useEffect, useRef } from "react";
import { Button } from "@progress/kendo-react-buttons";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormTextField from "../../components/formFields/FormTextField";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";

import { closed } from "../../components/muidrawer/muiDrawerSlice";
import { Typography } from "@progress/kendo-react-common";
import { RxCross1 } from "react-icons/rx";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { STATUSARRAY } from "../../_contstants/common";
import { clearCompetitorsDetails } from "./competitorsSlice";
import {
  createCompetitors,
  getAllActiveCompetitors,
  getAllCompetitors,
  getCompetitorsByID,
  updateCompetitors,
} from "./services/competitorsServices";

// import { closed } from "../../components/drawer/drawerSlice";

const CreateCompetitors: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);

  const CompetitorsDetail = useAppSelector(
    (state) => state.competitors.CompetitorsDetail
  );
  const competitors_guid = useAppSelector((state) => state.muidrawer.data);
  const formLoading = useAppSelector((state) => state.competitors.formLoading);
  const isIndirect = useAppSelector((state) => state.muidrawer.isIndirect);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  useEffect(() => {
    return () => {
      dispatch(clearCompetitorsDetails());
      dispatch(closed());
    };
  }, []);

  useEffect(() => {
    if (competitors_guid) {
      dispatch(getCompetitorsByID(competitors_guid));
    }
  }, [competitors_guid]);

  const handleSubmit = async (values: any) => {
    try {
      if (!competitors_guid) {
        const insertPayload = {
          competitors: values.competitors,

          isactive: values.isactive === 1,
        };
        const response = await dispatch(createCompetitors(insertPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearCompetitorsDetails());
          const payload = {
            competitors: "",
            limit: +pageLimit,
            skip: +currentPage * +pageLimit,
          };

          isIndirect
            ? dispatch(getAllActiveCompetitors())
            : dispatch(getAllCompetitors(payload));
        }
      } else {
        const editPayload = {
          competitors_guid: values.competitors_guid,
          competitors: values.competitors,

          isactive: values.isactive === 1,
        };
        const response = await dispatch(updateCompetitors(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearCompetitorsDetails());
          const payload = {
            competitors: "",
            limit: +pageLimit,
            skip: +currentPage * +pageLimit,
          };
          isIndirect
            ? dispatch(getAllActiveCompetitors())
            : dispatch(getAllCompetitors(payload));
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleFormClose = () => {
    dispatch(closed());
  };

  if (formLoading) return <LoadingPanel gridRef={gridRef} />;

  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={CompetitorsDetail}
      render={(formRenderProps: FormRenderProps) => (
        <FormElement style={{ width: "100%" }}>
          <GridLayout
            style={{
              display: "flex",
              flexWrap: "wrap",
            }}
            gap={{ rows: 10 }}
            cols={[{ width: "100%" }]}
          >
            <GridLayoutItem
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                margin: "17px 0 8px",
              }}
            >
              <Typography.h4 className="m-0">
                {competitors_guid ? "Update Competitor" : "Add Competitor"}
              </Typography.h4>
              <Button
                type="button"
                fillMode={"flat"}
                themeColor={"dark"}
                style={{ marginRight: 4 }}
                onClick={() => dispatch(closed())}
              >
                <RxCross1 />
              </Button>
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="competitors"
                label="Competitor Name"
                placeholder="Competitors"
                component={FormTextField}
                validator={requiredValidator}
                astrike={true}
              />
            </GridLayoutItem>

            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                id={"isactive"}
                name={"isactive"}
                label={"Status"}
                component={FormSelectionField}
                validator={requiredValidator}
                astrike={true}
                options={STATUSARRAY?.map((status: any) => {
                  return {
                    value: status.value,
                    label: status.label,
                  };
                })}
              />
            </GridLayoutItem>
            <GridLayoutItem
              colSpan={3}
              style={{
                textAlign: "start",
                marginTop: "20px",
                width: "100%",
              }}
            >
              <ButtonWithLoading
                label={competitors_guid ? "Update" : "Save"}
                type="submit"
                disabled={!formRenderProps.allowSubmit || formLoading}
                loading={formLoading}
              />
              <Button
                type="button"
                fillMode={"outline"}
                themeColor={"primary"}
                style={{ marginLeft: 4 }}
                onClick={handleFormClose}
              >
                Cancel
              </Button>
            </GridLayoutItem>
          </GridLayout>
        </FormElement>
      )}
    />
  );
};

export default CreateCompetitors;
